/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-boolean-value */
// eslint-disable-next-line react/no-array-index-key
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Navigation, Pagination, Scrollbar, A11y, Autoplay,
} from 'swiper/modules';
import { useLanguage } from '../contexts/LanguageContext.js';

import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function Testimonial({ data }) {
  const { t } = useLanguage();

  return (
    <section className="container mx-auto">
      <Fade direction="up">
        <h1 className="text-5xl text-white text-center font-bold">{t('testimonial')}</h1>
      </Fade>
      <Fade direction="up" delay={500}>
        <p className="font-medium text-lg text-white text-center mb-3 sm:mb-3 xl:mb-4">
          {t('testimonialDesc')}
        </p>
      </Fade>
      {/* eslint-disable-next-line react/jsx-max-props-per-line */}
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        className="mySwiper"
        loop={true}
        navigation={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
      >
        {data.map((item) => {
          // Get translation keys based on item id
          let nameKey = '';
          let companyKey = '';
          let textKey = '';
          
          if (item.id === 1) {
            nameKey = 'testimonial1Name';
            companyKey = 'testimonial1Company';
            textKey = 'testimonial1Text';
          } else if (item.id === 2) {
            nameKey = 'testimonial2Name';
            companyKey = 'testimonial2Company';
            textKey = 'testimonial2Text';
          } else if (item.id === 3) {
            nameKey = 'testimonial3Name';
            companyKey = 'testimonial3Company';
            textKey = 'testimonial3Text';
          }
          
          return (
            <SwiperSlide key={item.id}>
              <div className="flex-col xl:w-full rounded-2xl shadow-xl sm:shadow-2xl border px-8 py-6 mx-2 mb-6 mt-6 xl:mx-auto sm:mx-6 sm:mb-12 border-t border-gray-200 pb-6" style={{ backgroundColor: "rgba(249,250,251,0.8)", borderRadius: "1rem" }}>
                <div className="flex items-center mb-5">
                  <img src={item.imageUrl} alt="Testimoni" className="w-20 h-20 rounded-full" />
                  <div className="flex-col pl-5">
                    <h2 className="text-black text-2xl">{t(nameKey)}</h2>
                    <p className="font-bold text-green-900">{t(companyKey)}</p>
                  </div>
                </div>
                <p className="font-normal text-2xl text-green-950 pl-5 pt-3 pb-1">
                  {t(textKey)}
                </p>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
}
